import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@music-vine/cadence/ui';
import { useRouter } from 'next/router';

import { logEvent } from '@/pages/api/v1/utils';
import {
  getGetApiV1WhitelistQueryKey,
  useDeleteApiV1WhitelistId,
} from '@/open-api/whitelist/whitelist';

export const useRemoveChannel = () => {
  const queryClient = useQueryClient();
  const { asPath } = useRouter();
  const queryKey = getGetApiV1WhitelistQueryKey();

  const mutation = useDeleteApiV1WhitelistId({
    mutation: {
      onMutate: (variables) => {
        void logEvent({
          event_type: 'remove_safelist_channel',
          asPath,
          metadata: {
            channel_id: variables.id.toString(),
          },
        });
      },
      onSuccess: () => {
        toast.success('Channel unsafelisted', { closeButton: false });
      },
      onSettled: () => {
        // Clear errored state so the query can re-enable and refetch on the next render
        const cachedQuery = queryClient.getQueryState(queryKey);
        if (cachedQuery?.status === 'error') {
          queryClient.removeQueries({ queryKey });
        }
        queryClient.invalidateQueries({ queryKey });
      },
    },
  });

  const removeChannel = (channelId: number) =>
    mutation.mutateAsync({ id: channelId });

  return {
    removeChannel,
    isRemoving: mutation.isPending,
    error: mutation.error
      ? 'Something went wrong while removing the channel.'
      : undefined,
  };
};
